/** @jsx jsx */
import { Fragment, /* useContext,*/ useEffect, useState } from 'react';
import { NextPage } from 'next';
import { Auth } from 'aws-amplify';
import { useRouter } from 'next/router';
import { jsx } from '@balance-web/core';
import { Field } from '@balance-web/field';
import { Flex } from '@balance-web/flex';
import { TextInput } from '@balance-web/text-input';
import { Box } from '@balance-web/box';
import { Heading } from '@balance-web/heading';
import { Columns } from '@balance-web/columns';
import { Button } from '@balance-web/button';
import { Text } from '@balance-web/text';

import { SelectField } from '../generic/SelectField';

// import { IdContext } from '../../context';

// FIXME: Move to constants
const regionOptions = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
] as const;

type RegionType = typeof regionOptions[number]['value'];

// FIXME: Replace `any` declarations
export const ModifyPhone: NextPage<{
  phone: string;
  setPhone?: any;
  region: RegionType | undefined;
  setRegion: (value: RegionType) => void;
  canModify?: boolean;
}> = ({ phone, setPhone, region, setRegion, canModify }) => {
  const [user, storeUser] = useState<any>({});
  const [modify, setModify] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const router = useRouter();
  useEffect(() => {
    if (!user || !user.attributes)
      Auth.currentAuthenticatedUser()
        .then((user: any | null) => {
          storeUser(user);
        })
        .catch(() => router.push('/login'));
  }, [router, user, storeUser]);

  const validatePhone = (number: string) => {
    if (region === 'AU' && number.length === 12) {
      setErrorMessage(null);
    } else {
      setErrorMessage('Invalid Phone Number');
    }
  };

  const countryCodes = { AU: '+61', NZ: '+64', GB: '+44' };
  const countryCode = region ? countryCodes[region] : '';

  const updatePhone = () => {
    // TODO::: should update portal too
    Auth.updateUserAttributes(user, {
      locale: region,
      phone_number: phone,
    }).catch((err) => console.error(err));
  };
  return (
    <Fragment>
      <Flex
        direction="column"
        gap="medium"
        alignItems="center"
        padding="xlarge"
      >
        {!region && (
          <SelectField
            onChange={setRegion}
            value={region}
            label="Country"
            options={regionOptions}
          />
        )}
        <Heading level="3" text-align="left">
          Phone Number
        </Heading>
        <Columns template={[3, 6, 3]} gap="medium">
          <Field label="Country code" labelVisible={false}>
            <TextInput
              type="text"
              disabled
              onChange={() => {}} // TODO: add an onchange event
              value={countryCode}
            />
          </Field>
          <Field label="Country code" labelVisible={false}>
            <TextInput
              type="text"
              value={phone.replace(countryCode, '')}
              disabled={canModify && !modify}
              onChange={(e) => {
                e.preventDefault();
                const num = countryCode + e.target.value;
                setPhone(num);
                validatePhone(num);
              }}
            />
            {errorMessage ? (
              <Text color="critical" size="small">
                {errorMessage}
              </Text>
            ) : (
              <Text color="informative" size="small"></Text>
            )}
          </Field>
          <Box>
            {canModify && (
              <Box borderRadius="small">
                <Button
                  id="revoke-mfa"
                  disabled={!!(errorMessage || !phone || !region)}
                  size="medium"
                  block
                  onClick={() => {
                    if (!modify) setModify(true);
                    else updatePhone();
                  }}
                  label="Modify"
                />
              </Box>
            )}
          </Box>
        </Columns>
      </Flex>
    </Fragment>
  );
};
